<template>
  <BlockContainer class="p-5">
    <h4>Takk!</h4>

    <div class="mt-5">
      <p>
        Din leietaker {name} har nå fått tilsendt en e-post hvor du stiller krav om kjøp av depositumsgaranti som
        sikkerhet for leieforholdet deres.
      </p>
      <p>
        Så snart {name} har bestilt og betalt for depositumsgarantien så vil du får en e-post hvor du bes bekrefte
        detaljene.
      </p>
    </div>

    <div class="mt-5">
      <p>
        Din leietaker {name} har nå fått tilsendt en e-post hvor du oppfordrer til kjøp av depositumsgaranti som
        sikkerhet for leieforholdet deres.
      </p>
      <p>
        Så snart {name} har bestilt og betalt for depositumsgarantien så vil du får en e-post hvor du bes bekrefte
        detaljene.
      </p>
    </div>

    <div class="mt-5">
      <router-link :to="{ name: 'tenancy_overview' }" tag="button" class="btn btn-primary"
        >Tilbake til leieforholdet</router-link
      >
    </div>
  </BlockContainer>
</template>

<script>
import BlockContainer from '@/components/BlockContainer';
export default {
  components: {
    BlockContainer,
  },
};
</script>
